import { render, staticRenderFns } from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=template&id=b0d6c52e&scoped=true&"
import script from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageObjectDrawer.vue?vue&type=style&index=0&id=b0d6c52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d6c52e",
  null
  
)

export default component.exports